import { render, staticRenderFns } from "./print_completion_certificate.vue?vue&type=template&id=7d5cea32&"
import script from "./print_completion_certificate.vue?vue&type=script&setup=true&lang=js&"
export * from "./print_completion_certificate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports